export default {
  authUser: state => {
    return state.user
  },

  authToken: state => {
    return state.token
  },

  downloadFile: state => {
    return state.downloadable
  },

  showForm: state => {
    return state.form
  },

  beginSurvey: state => {
    return state.survey
  },

  nextQuestion: state => {
    return state.survey
  },

  prevQuestion: state => {
    return state.survey
  },

  finishSurvey: state => {
    return state.survey
  },

  caseStudies: state => {
    return state.cases
  },

  currentCase: state => {
    return state.currentCase
  }

}



// WEBPACK FOOTER //
// ./src/store/getters.js